import React from 'react';
import { RotateCcwIcon } from 'lucide-react';
import { Field, Select } from '../ui/Field';
import { DEFAULT_FILTERS } from '../../utils/housing';
import type { Facility, HousingFilters } from '../../types/housing';
const FACILITIES: Facility[] = ['Furnished', 'Electricity', 'Running water', 'Internet', 'Security', 'Power backup', 'Kitchen', 'Laundry', 'Study area', 'Parking'];
const DISTANCES = [10, 15, 20, 30, 45, 60];
interface FilterRailProps {
  filters: HousingFilters;
  onChange: (filters: HousingFilters) => void;
  resultCount: number;
}
export function FilterRail({
  filters,
  onChange,
  resultCount
}: FilterRailProps) {
  function toggleFacility(facility: Facility) {
    onChange({
      ...filters,
      facilities: filters.facilities.includes(facility) ? filters.facilities.filter(item => item !== facility) : [...filters.facilities, facility]
    });
  }
  return <div className="space-y-5" data-id="element-1656" data-mp="23s0249nwk762">
      <div className="flex items-baseline justify-between gap-3" data-id="element-1657" data-mp="23st2msw9q0fr">
        <p className="cz-num text-[13px] font-semibold text-ink" data-id="element-1658" data-mp="2glob76ypx7do">{resultCount} listings</p>
        <button type="button" onClick={() => onChange(DEFAULT_FILTERS)} className="inline-flex items-center gap-1.5 text-[12px] font-medium text-ink-muted transition-colors duration-150 ease-out hover:text-ink" data-id="element-1659" data-mp="2lkhph1ltx2ew">
          <RotateCcwIcon className="h-3 w-3" data-id="element-1660" data-mp="2vb2jscugzks0" />
          Reset
        </button>
      </div>

      <Field label="Sort by" htmlFor="filter-sort" data-id="element-1661" data-mp="2zd7e7dsqslfp">
        <Select id="filter-sort" value={filters.sort} onChange={event => onChange({
        ...filters,
        sort: event.target.value as HousingFilters['sort']
      })} data-id="element-1662" data-mp="348witvjmcsiv">
          <option value="recommended" data-id="element-1663" data-mp="3e7lpes62eqjt">Recommended</option>
          <option value="price_asc" data-id="element-1664" data-mp="1evj91qsqmcad">Lowest rent</option>
          <option value="distance" data-id="element-1665" data-mp="1ewuf5x9nnw4n">Closest to campus</option>
        </Select>
      </Field>

      <Field label="Maximum travel time" htmlFor="filter-distance" data-id="element-1666" data-mp="1jucnpmjrg9c4">
        <Select id="filter-distance" value={String(filters.maxMinutes)} onChange={event => onChange({
        ...filters,
        maxMinutes: Number(event.target.value)
      })} data-id="element-1667" data-mp="1bug39tzzh6ov">
          {DISTANCES.map(minutes => <option key={minutes} value={minutes} data-id="element-1668" data-mp="1lphqulem20pc">
              Within {minutes} minutes
            </option>)}
        </Select>
      </Field>

      <Field label="Occupants per room" htmlFor="filter-occupants" data-id="element-1669" data-mp="1urh9tj96reux">
        <Select id="filter-occupants" value={filters.occupants === null ? 'any' : String(filters.occupants)} onChange={event => onChange({
        ...filters,
        occupants: event.target.value === 'any' ? null : Number(event.target.value)
      })} data-id="element-1670" data-mp="1pt5zz8iw54cp">
          <option value="any" data-id="element-1671" data-mp="2djs80zswaomp">Any</option>
          <option value="1" data-id="element-1672" data-mp="2dgntb8ht0ahs">Just me</option>
          <option value="2" data-id="element-1673" data-mp="29hyc14tna8sv">Two</option>
          <option value="3" data-id="element-1674" data-mp="29izwu10gq9ns">Three or more</option>
        </Select>
      </Field>

      <div data-id="element-1675" data-mp="2s6qx4o4a56y9">
        <p className="mb-2 text-[13px] font-medium text-ink" data-id="element-1676" data-mp="2s68sp47grmf9">Trust</p>
        <label className="flex cursor-pointer items-start gap-2.5" data-id="element-1677" data-mp="2x3hcf989fyim">
          <input type="checkbox" checked={filters.verifiedOnly} onChange={event => onChange({
          ...filters,
          verifiedOnly: event.target.checked
        })} className="mt-0.5 h-4 w-4 rounded border-line-strong text-brand-700 focus:ring-brand-700" data-id="element-1678" data-mp="2j516vlm4we22" />
          <span data-id="element-1679" data-mp="2e5obudl400oe">
            <span className="block text-[13px] text-ink" data-id="element-1680" data-mp="2e67p3gzte0w3">Verified listings only</span>
            <span className="block text-[12px] leading-5 text-ink-subtle" data-id="element-1681" data-mp="20ejift8c44mi">
              Owner identity and documents checked by Campuzon
            </span>
          </span>
        </label>
      </div>

      <fieldset data-id="element-1682" data-mp="1qgdivia03akt">
        <legend className="mb-2 text-[13px] font-medium text-ink" data-id="element-1683" data-mp="1qftyluwvoa3m">Facilities</legend>
        <div className="space-y-1.5" data-id="element-1684" data-mp="1vfq1trxr3xi4">
          {FACILITIES.map(facility => <label key={facility} className="flex cursor-pointer items-center gap-2.5" data-id="element-1685" data-mp="2xsl69q5usttq">
              <input type="checkbox" checked={filters.facilities.includes(facility)} onChange={() => toggleFacility(facility)} className="h-4 w-4 rounded border-line-strong text-brand-700 focus:ring-brand-700" data-id="element-1686" data-mp="2xufh2bnev5k3" />
              <span className="text-[13px] text-ink-muted" data-id="element-1687" data-mp="2jz3nw8owln5a">{facility}</span>
            </label>)}
        </div>
      </fieldset>
    </div>;
}